<template>
  <div id="app">
   <Sidebar
      :collapse="collapseState"
      :closeAll="closeAll"
      @collapseChange="toggleCollapseState()"
      @close="toggleCloseAll()"/>
    <div
      class="main"
      v-if="!awaitingTenantCulture && !awaitingAirportCultures"
      @click="toggleCloseAll()">
      <transition name="fade">
        <router-view :key="$route.fullPath" />
      </transition>
    </div>
  </div>
</template>

<script>
import store from './store/store'
import Sidebar from './components/sidebar/Sidebar.vue'
import moment from 'moment'

export default {
    name: 'App',
    components: {
        Sidebar
    },
    data(){
        return {
            awaitingTenantCulture: true,
            awaitingAirportCultures: true,
            retrievedAirportCultures: [],
            collapseState: Boolean,
            closeAll: false
        }
    },
    watch: {
        collapseState(val){
            immediate: true;
            var isMainVisible = document.getElementsByClassName("main").length>0;
            if(!isMainVisible) return

            if(val){
                document.getElementsByClassName("main")[0].classList.add("collapsed");
            } else {
                document.getElementsByClassName("main")[0].classList.remove("collapsed");
            }
        }
    },
    created(){
        // this.$store.dispatch('getFeatures');

        store.dispatch('getConfiguration', {
            section: 'CultureSettings',
            identifier: 'LanguageCode'
        }).then(() => {
            var locale = store.getters['getSpecificConfiguration']({
                section: 'CultureSettings',
                identifier: 'LanguageCode'
            });
            moment.locale(locale.languageCode.toLowerCase());

            this.awaitingTenantCulture = false;
        });

        store.dispatch('getAirports').then(airports => {
            airports.data.forEach(airport => {
                this.$store.dispatch('getConfiguration', {
                    section: 'AirportConfigurations',
                    identifier: airport.id
                }).then(config => {
                    this.retrievedAirportCultures.push(airport.id);

                    if (this.retrievedAirportCultures.length === airports.data.length) {
                        this.awaitingAirportCultures = false;
                    }
                });
            });
        });

        this.collapseState = false;
    },
    methods: {
        toggleCloseAll(){
            // TODO - make into event
            if(this.collapseState){
                this.closeAll = !this.closeAll;
            }
        },
        toggleCollapseState(){
            this.collapseState = !this.collapseState;
        }
    }
}
</script>

<style lang="scss">
@import '../../node_modules/bootstrap/scss/bootstrap.scss';
@import 'assets/styles/index.scss';
@import "../../node_modules/font-awesome/css/font-awesome.min.css";
@import "../../node_modules/@mag/mag-components-sidebar/src/styles.scss";

.main {
  margin-left: 350px;
  padding: 0px;
  transition: margin-left 0.3s ease;
  padding-bottom: 100px;
}
.main.collapsed {
    margin-left: 50px;
    transition: margin-left 0.3s ease;
}
</style>
